import { render, staticRenderFns } from "./Sgtest.vue?vue&type=template&id=76b88df8&scoped=true&"
import script from "./Sgtest.vue?vue&type=script&lang=js&"
export * from "./Sgtest.vue?vue&type=script&lang=js&"
import style0 from "./Sgtest.vue?vue&type=style&index=0&id=76b88df8&lang=scss&scoped=true&"
import style1 from "./Sgtest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b88df8",
  null
  
)

export default component.exports